'use client';

import { ENV_IS_PRODUCTION } from 'constants/env';
import { IntlError } from 'next-intl';
import { notifyException } from 'services/appsignal';
import { ESpansException } from 'types/ESpans';

export const onErrorMessage = (error: IntlError) => {
  const info = {
    ...error,
    code: error.code,
    message: `Key: ${error.originalMessage} 

${error.message}`
  };

  notifyException(error, ESpansException.IntlErrorException, info);
};

export function getMessageFallback(info: { error: IntlError; key: string; namespace?: string }) {
  const { error, ...params } = info;

  notifyException(info.error, ESpansException.IntlFallbackException, params);

  return ENV_IS_PRODUCTION ? '' : String(info.key).toLocaleUpperCase();
}
